import React, { Component } from 'react'

import P2Closed from '../img/P2-sm-close.svg'
import P2Open from '../img/P2-sm-open.svg'
import P20Closed from '../img/P20-sm-close.svg'
import P20Open from '../img/P20-sm-open.svg'
import P200Closed from '../img/P200-sm-close.svg'
import P200Open from '../img/P200-sm-open.svg'
import P1000Closed from '../img/P1000-sm-close.svg'
import P1000Open from '../img/P1000-sm-open.svg'

const images = {
  P2Closed: P2Closed,
  P2Open: P2Open,
  P20Closed: P20Closed,
  P20Open: P20Open,
  P200Closed: P200Closed,
  P200Open: P200Open,
  P1000Closed: P1000Closed,
  P1000Open: P1000Open
}

export default class Graphics extends Component {
  render(){
    return(
      <div className="graphics">
        <img
          style={{ pointerEvents: "none" }}
          src={
            (this.props.open)?
               images[this.props.type+"Open"]
              :images[this.props.type+"Closed"]
            }
          alt={this.props.type+' tip box'}
        />
      </div>
    )
  }
}
